export default __webpack_public_path__ + "static/media/background-view.b453535e.png";